import { ArrowUpRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { Chapter, Reveal } from "@/components/site/Reveal";

const SERVICES = [
    {
        title: "Artificial Turf Installation",
        desc: "Hyper-realistic turf engineered for Idaho summers and winters. Soft underfoot, brutal on wear.",
        img: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/coj2kioo_43.jpeg",
        span: "md:col-span-7",
        tag: "Lawns",
        slug: "artificial-turf-lawns",
    },
    {
        title: "Backyard Putting Greens",
        desc: "Tournament-grade greens, custom contoured. Practice your short game without leaving home.",
        img: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/pdqcysro_IMG_1222.jpeg",
        span: "md:col-span-5",
        tag: "Golf",
        slug: "backyard-putting-greens",
    },
    {
        title: "Pet & Play Areas",
        desc: "Mud-free, drainable turf built for muddy paws, kids, trampolines, and everything in between.",
        img: "https://customer-assets.emergentagent.com/job_treasure-turf/artifacts/f6bijx28_IMG_1437.jpeg",
        span: "md:col-span-12",
        tag: "Family",
        slug: "pet-turf",
    },
];

export const Services = () => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36"
        >
            <Chapter
                index="01"
                label="Services"
                testid="services-chapter"
                title={
                    <>
                        Built for Idaho.{" "}
                        <span className="italic text-brand-accent">Perfected</span>{" "}
                        for your yard.
                    </>
                }
                copy="Whether it's a patch of dust in Boise or a half-acre in Eagle, every install is custom-shaped, hand-laid, and locked down to last a decade or more."
            />

            <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
                {SERVICES.map((s, i) => (
                    <Reveal
                        key={s.title}
                        delay={i * 0.08}
                        className={s.span}
                    >
                        <article
                            data-testid={`service-card-${i}`}
                            className="spotlight group relative h-full overflow-hidden rounded-3xl border border-brand-border bg-white transition-colors duration-500 hover:border-brand-accent/40"
                        >
                            <div className="relative aspect-[16/10] overflow-hidden md:aspect-[16/9]">
                                <img
                                    src={s.img}
                                    alt={s.title}
                                    loading="lazy"
                                    className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent" />
                                <span className="absolute left-5 top-5 inline-flex items-center rounded-full border border-white/15 bg-black/50 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                                    {s.tag}
                                </span>
                                <span className="font-display absolute right-5 top-4 text-4xl font-light italic text-white/50">
                                    0{i + 1}
                                </span>
                            </div>
                            <div className="flex items-end justify-between gap-6 p-7">
                                <div>
                                    <h3 className="font-display text-2xl font-medium tracking-tight text-brand-text">
                                        {s.title}
                                    </h3>
                                    <p className="mt-2 max-w-md text-sm leading-relaxed text-brand-muted">
                                        {s.desc}
                                    </p>
                                </div>
                                <Link
                                    to={`/services/${s.slug}`}
                                    data-testid={`service-cta-${i}`}
                                    aria-label={`Learn more about ${s.title}`}
                                    className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-brand-border bg-brand-bg text-brand-text transition-all duration-300 group-hover:border-brand-accent group-hover:bg-brand-accent group-hover:text-white"
                                >
                                    <ArrowUpRight size={18} weight="bold" />
                                </Link>
                            </div>
                        </article>
                    </Reveal>
                ))}
            </div>
        </section>
    );
};
